// extracted by mini-css-extract-plugin
module.exports = {"amount":"bill_amount__21lrc","customerInfo":"bill_customerInfo__3RiuT","customerDetail":"bill_customerDetail__3Qut3","billInfo":"bill_billInfo__2CoVj"};